<template>
    <div class="city-box">
        <div class="city-title"><span class="city-name">当前所在城市：<span>{{currentCity}}</span></span><a class="goback-hq" @click="gobackHq" v-if="currentCity != '全国行情'">返回全国行情 >></a></div>
        <div class="city-content" v-if="isShowCityList">
            <div class="city-list" :class="{'open' : anOrClose}">
                <p class="citys" v-for="(items,index) in clusterCityListsSplice" :key="index">
                    <a v-for="(item,index) in items" :key="index" @click="changCity(item)">{{item.name}}<font>({{item.count}})</font></a>
                </p>
            </div>
            <div>
                <a class="close-all btn" v-if="anOrClose" @click="anOrClose = false;countAd(4543)">收起</a>
                <a class="open-all btn" v-else @click="anOrClose = true;countAd(4542)">展开</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ArticleMarket',
        props: {
            clusterCityLists: {
                type: Array,
                default: () => {[]}
            }
        },
        data() {
            return {
                currentCity: '全国行情', //选择的城市名字
                anOrClose: false, //展开或者收起
                isShowCityList: true, //控制显示城市列表
            }
        },
        methods: {
            changCity(city) {
                this.countAd(4541)
                this.currentCity = city.name
                this.isShowCityList = false
                this.$emit('marketSearch',city.name)
            },
            //返回全国行情
            gobackHq() {
                this.currentCity = '全国行情',
                this.isShowCityList = true,
                this.$emit('marketSearch')
            }
        },
        computed: {
            clusterCityListsSplice() {
                let list = []
                for(let i=0;i<Math.ceil(this.clusterCityLists.length/5);i++){
                    let start = i*5;
                    let end = start+5;
                    list.push(this.clusterCityLists.slice(start,end));
                }
                return list
            }
        },
    }
</script>

<style lang="scss" scoped>
.city-box {
    width: 618px;
    border: 1px solid #d7d7d7;
    margin-top: 15px;
    padding-bottom: 1px;
    .city-title {
        color: #333333;
        font-size: 14px;
        padding: 0 13px;
        line-height: 39px;
        font-weight: 600;
        display: flex;
        justify-content: space-between;
        .city-name {
            span {
                color:#ff6600;
            }
        }
        .goback-hq {
            font-size: 12px;
            color: #225599;
            font-weight: normal;
            cursor: pointer;
        }
    }
    .city-content {
        border-top: 1px solid #d7d7d7;
        .city-list {
            height: 132px;
            &.open {
                height: auto;
            }
            overflow: hidden;
            .citys {
                display: flex;
                border-bottom: 1px dashed #e4e4e4;
                line-height: 32px;
                a {
                    display: inline-block;
                    width: 108px;
                    height: 32px;
                    font-size: 12px;
                    color: #225599;
                    margin-left: 15px;
                    cursor: pointer;
                    font {
                        color: #777777;
                        margin-left: 5px;
                    }
                }
            }
        }
        .btn {
            display: block;
            margin: 0 auto;
            width: 616px;
            height: 26px;
            line-height: 26px;
            background: #f4f4f4;
            text-align: center;
            color: #333333;
            cursor: pointer;
            margin-top: -1px;
            &.open-all {
                background: url(//www1.pcauto.com.cn/2014/kuaisou/images/moreDown.png) 322px 9px no-repeat #f4f4f4;
            }
            &.close-all {
                background: url(//www1.pcauto.com.cn/2014/kuaisou/images/moreUp.png) 322px 9px no-repeat #f4f4f4;
            }
        }
    }
}
</style>